/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-06-14 19:46:58
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-28 17:21:38
 */
import axios from './axios'
import NProgress from 'nprogress'
import { Result } from '@/service/model'

interface Reauest {
  responseType: string
  customPost<T>(url: string, params: Record<string, any>, headers?: Record<string, any>): Promise<Result<T>>
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: unknown, responseType?: any): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

const request: Reauest = {
  customPost(url, params, headers = {}) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios.post(url, JSON.stringify(params), {
        headers
      })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  get(url, params) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .get(url, { params })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  post(url, obj?: any, isArraybuffer?) {
    const { switchApi, ...params } = obj || {}
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(switchApi || url, JSON.stringify(params), { responseType: isArraybuffer ? 'arraybuffer' : 'json' })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(url, file, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => {
          NProgress.done()
          resolve(res.data)
        })
        .catch((err) => {
          NProgress.done()
          reject(err.data)
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
